module.exports = __webpack_public_path__ + "static/media/ico-connect.24081b9f.svg";